/**
 * @file 推荐功能
 * @author alfielv
 */

import React, { useState, useCallback } from 'react';
import { Tag, Text, Flex, Frame } from '@tencent/odc';
import _ from 'lodash';
import { useResponsive } from '@tencent/od-hooks';

import { InstructionType, AI_ASSISTANT_REPORT_EVENT_NAME, FEATURE_TYPE, getRandomRecommendedCommands, SKILL_LIST } from '../../../constants';

const FeartureCard = ({ title, titleExtra, className, children }: { title: string, titleExtra?: React.ReactNode, className?: string, children: React.ReactNode }) => (
  <div
    className={`tw-flex tw-flex-col tw-gap-2 ${className}`}
  >
    <div className='tw-flex tw-justify-between tw-items-center'>
      <Text size="small" label={title} color="rgba(105, 118, 166, 1)" as='strong' />
      {titleExtra}
    </div>
    {children}
  </div>
);

export interface InstructionProps {
  /** 点击指令回调 */
  onClick: ({ type, text }: { type: InstructionType, text?: string }) => void;
}

const Instruction: React.FC<InstructionProps> = ({ onClick }) => {
  const [displayRecommendedCommands, setDisplayRecommendedCommands] = useState(() => getRandomRecommendedCommands());

  const handleRandomCommands = useCallback(() => {
    setDisplayRecommendedCommands(getRandomRecommendedCommands());
  }, []);
  const responsive = useResponsive();

  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-6 tw-py-[20px] tw-px-[24px] tw-rounded-[8px] tw-bg-coolgray-01">
      {/* 常用指令卡片 */}
      <FeartureCard
        className="tw-col-span-2"
        title="常用指令"
        titleExtra={(
          <Frame
            style={{ width: '16px', height: '16px' }}
            className='tw-cursor-pointer'
            onClick={() => {
              handleRandomCommands();
            }}
          >
            <img src="https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1762348015952.png?max_age=31536000" width={16} height={16} className='tw-block' />
          </Frame>
        )}
      >
        <div className="tw-grid tw-grid-cols-2 tw-gap-x-[12px] tw-gap-y-[4px]">
          {_.slice(displayRecommendedCommands, 0, 8).map((command) => (
            <div
              key={command.id}
              className="tw-py-[4px] tw-cursor-pointer tw-flex tw-overflow-hidden"
              onClick={() => onClick({
                type: InstructionType.CONTENT,
                text: command.text,
              })}
              data-report={`${AI_ASSISTANT_REPORT_EVENT_NAME.INSTRUCTION_COMMAND}__${command.id}`}
            >
              <div className="tw-flex tw-items-center tw-w-full tw-gap-[4px]">
                {command.tag && (
                  <Tag prefixCls="l-" label={command.tag} />
                )}
                <Text className='hover:tw-text-[#006FFF]' type="primary" label={command.text} block nowrap title={command.text} size='small' />
              </div>
            </div>
          ))}
        </div>
      </FeartureCard>

      {/* 推荐功能卡片 */}
      <FeartureCard className="tw-col-span-1" title="推荐功能">
        <Flex gap={8} className="tw-grid tw-grid-cols-2">
          {SKILL_LIST.map((command) => (
            <Flex
              key={command.id}
              justifyContent="between"
              alignItems="center"
              className="tw-p-[12px] tw-cursor-pointer tw-bg-white-00 tw-rounded-lg tw-h-[44px] tw-border-white-00 hover:tw-border-blue-01-b tw-border-[1px] tw-transition-all tw-duration-200"
              onClick={() => {
                // if (command.id === 'DASHBOARD') {
                //   window.open('//ad.qq.com/cm/analysis/ai-agent', '_blank');
                //   return;
                // }
                onClick({
                  type: InstructionType.AGENT,
                  text: command.id,
                });
              }}
              data-report={`${AI_ASSISTANT_REPORT_EVENT_NAME.INSTRUCTION_FEATURE}__${command.id}`}
            >
              <Flex column gap={4} className="tw-overflow-hidden">
                <Text
                  type="primary"
                  block
                  label={command.title}
                  className='tw-leading-[20px]'
                  size='small'
                  nowrap
                  {...responsive.md && { icon: <img src={command.iconUrl} width={16} height={16} /> }}
                />
              </Flex>
              <img src="//qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1761988976774.png?max_age=31536000" width={16} height={16} />
            </Flex>
          ))}
        </Flex>
      </FeartureCard>
    </div>
  );
};

export default Instruction;
